// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_menu-module__container--2TeBP"};